import { Table } from 'common/components/Table/Table'
import { TableSearchAndFilters } from 'common/components/TableSearchAndFilters/TableSearchAndFilters'
import { DEFAULT_TABLE_PARAMS_WITH_SEARCH } from 'common/constants/defaultTableParamsConstants'
import type { TableParamsType } from 'common/interfaces/ITable'
import type { ObjectType } from 'common/interfaces/object'
import { useLazyFetchTransactionsHistoryQuery } from 'features/Profile/features/TransactionsMapping/transactionsMapping.api'
import type { FC } from 'react'
import { memo, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { TRANSACTIONS_HISTORY_COLUMNS } from './columns'
import styles from './transactionHistory.module.scss'

export const TransactionHistory: FC = memo(() => {
  const [columns, setColumns] = useState<ObjectType[]>(TRANSACTIONS_HISTORY_COLUMNS)
  const [tableParams, setTableParams] = useState<TableParamsType>({
    ...DEFAULT_TABLE_PARAMS_WITH_SEARCH,
  })
  const { siteId } = useParams()
  const [fetchHistory, { data, isFetching }] = useLazyFetchTransactionsHistoryQuery()

  useEffect(() => {
    if (!siteId) return
    fetchHistory({
      siteId,
      tableParams: {
        ...tableParams,
        search: tableParams.debouncedValue?.length >= 2 ? tableParams.debouncedValue : '',
      },
    })
  }, [
    siteId,
    tableParams.pageSize,
    tableParams.current,
    tableParams.debouncedValue,
    JSON.stringify(tableParams.sorters),
  ])

  useEffect(() => {
    if (tableParams.sorters) {
      setColumns((prev) =>
        prev.map((column) => ({ ...column, sortOrder: tableParams.sorters?.[column.key]?.order })),
      )
    }
  }, [JSON.stringify(tableParams.sorters)])

  useEffect(() => {
    if (data?.total_items >= 0) {
      setTableParams((prev) => ({ ...prev, total: data.total_items }))
    }
  }, [data?.total_items])

  return (
    <div className={styles.parent}>
      <h1 className={styles['page-title']}>Transactions History</h1>
      <TableSearchAndFilters
        setTableParams={setTableParams}
        setColumns={setColumns}
        tableParams={tableParams}
        inputHint='Search by transaction id'
      />
      <Table
        itemKey='id'
        haveActions={false}
        tableParams={tableParams}
        setTableParams={setTableParams}
        dataSource={data?.items}
        columns={columns}
        isLoading={isFetching}
      />
    </div>
  )
})

export default TransactionHistory
